import { Box } from '@chakra-ui/core'
import { SearchableMenu } from 'components/AdminConsole/commonUI/SearchableMenu'
import useLocaleText from 'components/useLocaleText'
import { ListChecks, MessageSquare, PictureInPicture2, Database, PackageOpen } from 'lucide-react'
import React from 'react'

const JOBS_ACTION_SERVICES = [
  { id: 'all', name: 'all_services', isShowId: false },
  { id: 'tasks', name: 'jobs_tasks', icon: <ListChecks />, isShowId: false },
  { id: 'pops', name: 'jobs_pops', icon: <PictureInPicture2 />, isShowId: false },
  { id: 'posts', name: 'jobs_posts', icon: <MessageSquare />, isShowId: false },
  { id: 'data', name: 'jobs_data', icon: <Database />, isShowId: false },
  { id: 'compaign', name: 'jobs_compaign', icon: <PackageOpen />, isShowId: false },
]

interface IFilterByService {
  selectedService: string
  setSelectedService: (id: string) => void
}

export const FilterByService: React.FC<IFilterByService> = ({ selectedService, setSelectedService }) => {
  const admin_select_placeholder = useLocaleText('admin_select_placeholder')
  return (
    <Box w="max-content" minW="200px" maxW="300px">
      <SearchableMenu
        isShowSearch={false}
        items={JOBS_ACTION_SERVICES}
        selectedId={selectedService}
        isLocalTranslation
        placeholder={admin_select_placeholder}
        onSelect={(item) => {
          setSelectedService(item.id)
        }}
      />
    </Box>
  )
}
